module.exports = __webpack_public_path__ + "static/img/logo.07748d43.png";